import Vue from 'vue';
import App from '@/App.vue';
import i18n from '@/locales';
import '@/scss/main.scss';

// Custom elements polyfill for IE11
import '@ungap/custom-elements';
import vueCustomElement from 'vue-custom-element';

Vue.use(vueCustomElement);

Vue.config.productionTip = false;

// Make base URL configurable at runtime
const baseUrl = document.getElementById('core-availability-script').getAttribute('data-base-url');

App.i18n = i18n;
Vue.customElement('core-availability', App, {
  constructorCallback() {
    this.addEventListener('refresh', (e) => {
      const refresh = new Event('refresh');
      this.firstChild.dispatchEvent(refresh);
    })
  },
  beforeCreateVueInstance(RootComponentDefinition) {
    RootComponentDefinition.propsData.baseUrl = baseUrl;
    return RootComponentDefinition;
  },
});
